<template>
  <div class="course-lesson-list">
    <div v-if="lessonList.length"
         class="course-sort"
         @click="changeSort"
    >
      <ym-icon class="icon"
               name="mr-sort"
      />
      {{ sortText }}
    </div>
    <item v-for="(item,index) in lessonList"
          :key="index"
          :course-id="courseId"
          :lesson="{
            id: item.id,
            title: item.title,
            seq: item.seq,
          }"
          :work="item.work"
          :practice="item.practice"
          :challenge="item.challenge"
          :summary="item.summary"
    />
  </div>
</template>

<script>
  import Item from '@/pages/Course/components/CourseDetailChallengeItem';

  export default {
    name: 'CourseDetailLessonList',
    components: {
      Item,
    },
    props: {
      courseId: {
        type: Number,
        required: true,
      },
      list: {
        type: Array,
      },
    },
    data() {
      return {
        lessonList: [],
        sortText: '正序',
      };
    },
    watch: {
      list: {
        handler(val) {
          if (val) this.lessonList = val;
        },
        immediate: true,
      },
    },
    methods: {
      changeSort() {
        this.lessonList.reverse();
        this.sortText = this.sortText === '正序' ? '倒序' : '正序';
      },
    },
    created() {},
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .course-lesson-list {
    position: relative;
    padding-top: 60px;
    padding-bottom: @size-base;
    overflow: auto;
    background: #f5f6f7;
  }

  .course-sort {
    position: absolute;
    top: @size-base;
    right: @size-base;
    z-index: 2;
    width: 104px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: @color-white;
    color: @color-text-lighter;
    font-size: @font-size-small;
    border-radius: 13px;
    cursor: pointer;
  }
</style>
